import React, { useContext } from 'react';
import { SugiIcon } from 'src/components/shared/elements/icons/SugiIcon';
import { TokyuIcon } from 'src/components/shared/elements/icons/TokyuIcon';
import { I18nContext } from 'src/stores/I18n';
import styles from './index.module.scss';

type Props = {
  text: string;
  isCategoryDrug: boolean;
};

export const ProductLabel: React.FC<Props> = ({ text, isCategoryDrug }) => {
  const localeResources = useContext(I18nContext);
  return (
    <div className={styles.container}>
      <div className={styles.vendor}>
        {localeResources.commons.vendor}:
        <span className="ml-1">{isCategoryDrug ? <SugiIcon className="w-18 h-4" /> : <TokyuIcon />}</span>
      </div>
      {isCategoryDrug && <em className={styles.text}>{text}</em>}
    </div>
  );
};
